
import { Options, Vue } from "vue-class-component";
import DonutChart from "./charts/donut-chart.vue";

@Options({
  components: {
    DonutChart,
  },
})
export default class SectionPercentageDexAttempt extends Vue {}
